<style>

.input{
  display: grid;
  grid-template-columns: 55px 15px;
}
.number{
  grid-column: 1;
}
.arrow{
  grid-column: 2;
}

</style>

<div class="input" on:click="{ () => dispatch('showYears') }">
  <div class="month">{year}</div>
  <div class="arrow"><i class="icon-keyboard_arrow_down"></i></div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let year = "YYYY";

</script>